import { useEffect, useState } from "react";

// Shared live rate (single fetch, module-level cache). Source of truth:
// /api/rate → the same Pega Pay/Rupora tenant rate used by the app.
let cache = null;
let inflight = null;

function load() {
  if (!inflight) {
    inflight = fetch("/api/rate")
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => (d?.available && typeof d.rate === "number" ? d.rate : null))
      .catch(() => null)
      .then((rate) => {
        cache = rate;
        inflight = null;
        return rate;
      });
  }
  return inflight;
}

export function useLiveRate() {
  const [rate, setRate] = useState(cache);
  useEffect(() => {
    let alive = true;
    load().then((r) => alive && setRate(r));
    return () => {
      alive = false;
    };
  }, []);
  return rate;
}

// Indicative marketing range derived from the live admin-controlled rate.
export function rateRangeText(rate) {
  if (typeof rate !== "number") return "₹110–₹115";
  const lo = Math.floor(rate);
  const hi = Math.ceil(rate + 5);
  return `₹${lo}–₹${hi}`;
}
